import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';

export interface AppModuleOptions {
  router: AppVueRouter;
  menu: AppMenu;
  translationsMapper: TranslationKeysMapper;
}

export abstract class AppModule {
  protected submodules: AppModule[] = [];

  abstract addRoutes(router: AppVueRouter): void;

  abstract addMenu(menu: AppMenu): void;

  abstract addTranslationKeys(mapper: TranslationKeysMapper): void;

  install(options: AppModuleOptions): void {
    this.addTranslationKeys(options.translationsMapper);
    this.addMenu(options.menu);
    this.addRoutes(options.router);

    for (const submodule of this.submodules) {
      submodule.install(options);
    }
  }
}
